import type { SerializedManufacturer } from '@enmon/commons/lib/tools';
import { Input } from 'antd';
import type { DescriptionsColumn } from 'components/enmon/descriptions/Descriptions';

export const getManufacturerColumns = (): DescriptionsColumn<SerializedManufacturer>[] => [
  {
    name: 'name',
    label: 'Name',
    editable: true,
    required: true,
    formItemProps: { required: true, rules: [{ required: true, message: 'Name is required' }] },
    editContent: <Input placeholder="Name" />,
    render: (manufacturer: SerializedManufacturer) => manufacturer.name,
  },
  {
    name: 'website',
    label: 'Website',
    editable: true,
    editContent: <Input placeholder="Website" />,
    render: (manufacturer: SerializedManufacturer) => manufacturer.website,
  },
  {
    name: 'internal_note',
    label: 'Internal note',
    editable: true,
    editContent: <Input.TextArea placeholder="Internal note" rows={6} />,
    render: (manufacturer: SerializedManufacturer) => manufacturer.internal_note,
  },
];
